<template>
    <div class="comSearch">
        <el-input placeholder="请输入拍品名称" v-model="keyword" class="inputStyle">
            <template slot="append">
                <span class="searchSelf" @click="searchKeyWork(1)">
                    搜索本站
                </span>
            </template>
        </el-input>
        <span class="searchArt" @click="searchKeyWork(2)">搜索雅昌站</span>
    </div>
</template>

<script>
import { sentSensors } from '@/utils/buriedPoint.js'
export default {
    name: "search",
    data(){
        return{
            keyword:this.$route.query.keyword ? decodeURIComponent(this.$route.query.keyword) : ''
        }
    },
    methods:{
        searchKeyWork(val){
            // 神策埋点
            sentSensors('机构专区', this.keyword)
            // if(this.keyword.trim()=='' || this.keyword=="请输入拍品名称"){
            //     this.$alert('请填写搜索词！','',{
            //         confirmButtonText:'确定',
            //     });
            //     return;
            // }
            let link= '';
            if(val===1){
                // link='//auction.artron.net/jiade/item/?title='+this.keyword;
                this.$router.push({
                    name:'comItem',
                    query:{
                        keyword:encodeURIComponent(this.keyword)
                    }
                });
            }else if(val===2){
                link='//artso.artron.net/auction/search_auction.php?keyword='+encodeURIComponent(this.keyword);
                window.open(link);
            }
        }
    }

}
</script>

<style scoped lang="scss">
.comSearch{
    display: inline-block;
    .inputStyle{
        height: 40px;
        line-height: 40px;
    }
    /deep/ .el-input-group__append{
        background: none;
        background-color: #000;
        text-indent: 0;
        width: 78px;
        height: 40px;
        font-family: '微软雅黑';
        border:0;
        color: #FFFFFF;
        text-align: center;
        margin: 0;
        padding:0;
        font-size: 12px;
        cursor: pointer;
        font-weight: bold;
        border-radius: 0;
    }
    /deep/ .el-input__inner{
        border-radius: 0;
        font-size: 12px;
        border: 1px solid #e6e6e6;
        width: 249px;
    }
    /deep/ .el-input-group{
        width: 327px;
    }
    .searchArt{
        font-family: "微软雅黑";
        color: #333333;
        font-size: 12px;
        margin-left: 7px;
        cursor: pointer;
    }
}
</style>